import type { Properties } from '@aegis-framework/pandora';
import ScreenComponent, { ScreenState } from '../../lib/ScreenComponent';

class HelpScreen extends ScreenComponent<Properties, ScreenState> {
	static override tag = 'help-screen';

	override render(): string {
		return `
			<button class="top left" data-action="back"><span class="fas fa-arrow-left"></span></button>
			<h2 data-string="Help">Help</h2>
			<div data-content="help">
				<p data-string="AdvanceHelp">To advance through the game, left-click or tap anywhere on the game screen or press the space key</p>
        <div class="help__sections">
          <div class="help__section">
            <h3 data-string="QuickMenu">Quick Menu</h3>
            <div class="help__section__item">
              <div data-content="symbols">
                <span class="fas fa-arrow-left" data-content="icon"></span>
              </div>
              <div data-content="instruction">
                <span data-string="BackButton">Go back</span>
              </div>
            </div>
            <div class="help__section__item">
              <div data-content="symbols">
                <span class="fas fa-eye"></span>
              </div>
              <div data-content="instruction">
                <span data-string="HideButton">Hide the text box</span>
              </div>
            </div>
            <div class="help__section__item">
              <div data-content="symbols">
                <span class="far fa-comments"></span>
              </div>
              <div data-content="instruction">
                <span data-string="DialogLogButton">Show the dialog log</span>
              </div>
            </div>
            <div class="help__section__item">
              <div data-content="symbols">
                <span class="fas fa-play-circle"></span>
              </div>
              <div data-content="instruction">
                <span data-string="AutoPlayButton">Enable auto play</span>
              </div>
            </div>
            <div class="help__section__item">
              <div data-content="symbols">
                <span class="fas fa-fast-forward"></span>
              </div>
              <div data-content="instruction">
                <span data-string="SkipButton">Enter skip mode</span>
              </div>
            </div>
            <div class="help__section__item">
              <div data-content="symbols">
                <span class="fas fa-save"></span>
              </div>
              <div data-content="instruction">
                <span data-string="SaveButton">Open the Save Screen</span>
              </div>
            </div>
            <div class="help__section__item">
              <div data-content="symbols">
                <span class="fas fa-undo"></span>
              </div>
              <div data-content="instruction">
                <span data-string="LoadButton">Open the Load Screen</span>
              </div>
            </div>
            <div class="help__section__item">
            <div data-content="symbols">
              <span class="fas fa-cog"></span>
                </div>
              <div data-content="instruction">
                <span data-string="SettingsButton">Open the Settings Screen</span>
              </div>
            </div>
            <div class="help__section__item">
              <div data-content="symbols">
                <span class="fas fa-times-circle"></span>
              </div>
              <div data-content="instruction">
                <span data-string="QuitButton">Quit Game</span>
              </div>
            </div>
          </div>
          <div class="help__section">
            <div class="row__column--12">
              <h3 data-string="KeyboardShortcuts">Keyboard Shortcuts</h3>
            </div>
            <div class="help__section__item">
              <div data-content="symbols">
                <span data-content="shortcut"><span class="fas fa-arrow-left" data-content="icon"></span></span>
              </div>
              <div data-content="instruction">
                <span data-string="BackButton">Go Back</span>
              </div>
            </div>
            <div class="help__section__item">
              <div data-content="symbols">
                <span data-content="shortcut">H</span>
              </div>
              <div data-content="instruction">
                <span data-string="HideButton">Hide the text box</span>
              </div>
            </div>
            <div class="help__section__item">
              <div data-content="symbols">
                <span data-content="shortcut">A</span>
              </div>
              <div data-content="instruction">
                <span data-string="AutoPlayButton">Enable auto play</span>
              </div>
            </div>
            <div class="help__section__item">
              <div data-content="symbols">
                <span data-content="shortcut">S</span>
              </div>
              <div data-content="instruction">
                <span data-string="SkipButton">Enter skip mode</span>
              </div>
            </div>
            <div class="help__section__item">
              <div data-content="symbols">
                <span data-content="shortcut">⇧ S</span>
              </div>
              <div data-content="instruction">
                <span data-string="SaveButton">Open the Save Screen</span>
              </div>
            </div>
            <div class="help__section__item">
              <div data-content="symbols">
                <span data-content="shortcut">⇧ L</span>
              </div>
              <div data-content="instruction">
                <span data-string="LoadButton">Open the Load Screen</span>
              </div>
            </div>
            <div class="help__section__item">
              <div data-content="symbols">
                <span data-content="shortcut">ESC</span>
              </div>
              <div data-content="instruction">
                <span data-string="SettingsButton">Open the Settings Screen.</span>
              </div>
            </div>
            <div class="help__section__item">
              <div data-content="symbols">
                <span data-content="shortcut">⇧ Q</span>
              </div>
              <div data-content="instruction">
                <span data-string="QuitButton">Quit Game</span>
              </div>
            </div>
          </div>
        </div>
			</div>
		`;
	}
}

export default HelpScreen;

